import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WhatsappLogo, DownloadSimple, LinkSimple, CircleNotch } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { renderShareCard } from "@/lib/shareCard";
import { useAuth } from "@/context/AuthContext";

export function inviteLink(user) {
  return `${window.location.origin}/${user?.user_id ? `?ref=${user.user_id}` : ""}`;
}

export function ShareCardDialog({ item, open, onOpenChange }) {
  const { user } = useAuth();
  const [card, setCard] = useState(null);
  const link = inviteLink(user);

  useEffect(() => {
    if (!open || !item) return;
    setCard(null);
    renderShareCard({ title: item.title, prompt: item.prompt, category: item.category, link }).then(setCard);
  }, [open, item]); // eslint-disable-line

  const text = `${item?.title} — a free Diwali prompt from SpeakToPrompt. Get all 12 free: ${link}`;

  const whatsapp = async () => {
    const file = card?.blob && new File([card.blob], "diwali-prompt.png", { type: "image/png" });
    if (file && navigator.canShare?.({ files: [file] })) {
      try { await navigator.share({ files: [file], text }); return; } catch (e) { if (e.name === "AbortError") return; }
    }
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
  };
  const download = () => {
    const a = document.createElement("a");
    a.href = card.url; a.download = `${(item.title || "diwali-prompt").toLowerCase().replace(/[^a-z0-9]+/g, "-")}.png`; a.click();
    toast.success("Card downloaded");
  };
  const copy = async () => { await navigator.clipboard.writeText(link); toast.success("Invite link copied"); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="share-card-dialog" className="max-w-md rounded-3xl p-6">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-semibold text-ink">Share the Diwali spirit</DialogTitle>
          <DialogDescription className="text-sm text-mist">Send this card to friends. Your invite link is included.</DialogDescription>
        </DialogHeader>
        <div className="flex aspect-[4/5] items-center justify-center overflow-hidden rounded-2xl bg-[#3B0A1E]">
          {card ? <img data-testid="share-card-image" src={card.url} alt="Diwali share card" className="h-full w-full object-cover" /> : <CircleNotch size={28} className="animate-spin text-white" />}
        </div>
        <div className="grid grid-cols-3 gap-2">
          <button data-testid="share-card-whatsapp" onClick={whatsapp} disabled={!card} className="col-span-3 flex h-12 items-center justify-center gap-2 rounded-full bg-[#25D366] font-semibold text-white hover:bg-[#1EBE5A] disabled:opacity-50">
            <WhatsappLogo size={20} weight="fill" /> Share on WhatsApp
          </button>
          <button data-testid="share-card-download" onClick={download} disabled={!card} className="col-span-3 flex h-10 items-center justify-center gap-1.5 rounded-full bg-black/5 text-sm font-medium text-ink hover:bg-black/10 disabled:opacity-50 sm:col-span-1"><DownloadSimple size={15} /> Image</button>
          <button data-testid="share-card-copy-link" onClick={copy} className="col-span-3 flex h-10 items-center justify-center gap-1.5 rounded-full bg-black/5 text-sm font-medium text-ink hover:bg-black/10 sm:col-span-2"><LinkSimple size={15} /> Copy invite link</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
